<template>
  <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <div class="container-fluid" style="padding: 0px 15px;">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
  },
  mounted() {
    const title = this.title || "Americana de Turismo";

    this.$store.commit("layout/updateTitle", title);
    document.title = title;
  },
};
</script>
